"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MethodContext_1 = __importDefault(require("./MethodContext"));
var ConfigStoreInterceptorProxy = /** @class */ (function () {
    function ConfigStoreInterceptorProxy(target, interceptorChain) {
        this.target = target;
        this.interceptorChain = interceptorChain;
    }
    ConfigStoreInterceptorProxy.prototype.intercept = function (key, queryContext, weblabContext) {
        var methodContext = new MethodContext_1.default(this.target, key, queryContext, weblabContext);
        return this.interceptorChain.proceed(methodContext);
    };
    ConfigStoreInterceptorProxy.prototype.getValue = function (key, context, weblabContext) {
        return this.intercept(key, context, weblabContext);
    };
    return ConfigStoreInterceptorProxy;
}());
exports.default = ConfigStoreInterceptorProxy;
